import { render } from "./StockItemWidget.vue?vue&type=template&id=485e877c&scoped=true&ts=true"
import script from "./StockItemWidget.vue?vue&type=script&lang=ts"
export * from "./StockItemWidget.vue?vue&type=script&lang=ts"

import "./StockItemWidget.vue?vue&type=style&index=0&id=485e877c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485e877c"]])

export default __exports__